import React from "react";
import { Link, useParams } from "react-router-dom";
import "./OrderSuccessPage.css";

const OrderSuccessPage = () => {
  const { orderId } = useParams();

  return (
    <div className="success-page">
      <div className="success-card">
        <div className="success-icon">✓</div>
        <h1 className="success-title">Order Placed!</h1>
        <p className="success-sub">
          Thank you for your order. Your order <strong>#{orderId}</strong> has been received and is being processed.
        </p>
        <p className="success-note">You will be notified once it is dispatched.</p>
        <div className="success-actions">
          <Link to="/orders" className="success-btn success-btn--primary">View Order History</Link>
          <Link to="/products" className="success-btn success-btn--secondary">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessPage;
